import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {ColumnsManagerModule} from '../../../components/columns-manager';
import {SwitchModule} from '../../../components/switch';
import {TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG, TableColumnsSizingMode} from '../../../components/tables/table';
import {L10nModule} from '../../../components/translate';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DEX_TX_HISTORY_TABLE_COLUMNS_DEF, DexTxHistoryTableColumnConfig} from '../dex-tx-history-table';
import {DexTxHistoryWidget} from '../dex-tx-history-widget';
import {DexTxHistoryWidgetSettings} from './dex-tx-history-widget-settings';

interface SettingsFormValue {
    title: string;
    columns: DexTxHistoryTableColumnConfig[];
    columnsResizingMode: TableColumnsSizingMode;
}

@Component({
    selector:    'dex-tx-history-widget-settings',
    imports: [
        L10nModule,
        ReactiveFormsModule,
        SwitchModule,
        ColumnsManagerModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './dex-tx-history-widget-settings.component.html'
})
export class DexTxHistoryWidgetSettingsComponent
    extends WidgetImplSettingsComponentBase<DexTxHistoryWidget> {

    @Input()
    public override widget: DexTxHistoryWidget;

    public form: TypedForm<SettingsFormValue>;

    public readonly tableColumnsDef = DEX_TX_HISTORY_TABLE_COLUMNS_DEF;

    public readonly TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG = TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG;

    private readonly widgetImpl = this.widget.implementationInstance;

    protected override buildForm(): void {
        const settings: DexTxHistoryWidgetSettings = this.widgetImpl.settings;

        this.form = new FormGroup({
            title: this.createTitleFormControl(settings),
            columns: this.createColumnsSettingsFormControl(settings),
            columnsResizingMode: this.createColumnsResizingModeFormControl()
        } satisfies TypedFormOwnControls<SettingsFormValue>);
    }

    private createColumnsSettingsFormControl(settings: DexTxHistoryWidgetSettings): FormControl {
        const control: FormControl = new FormControl(settings.columns);

        this.bindControlToSettings({control, settingsFieldName: 'columns'});

        return control;
    }

    private createColumnsResizingModeFormControl(): FormControl {
        const control: FormControl =
                  new FormControl(this.widgetImpl.settings.columnsResizingMode);

        this.bindControlToSettings({control, settingsFieldName: 'columnsResizingMode'});

        return control;
    }

}
